import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { useCallback } from 'react';
import { createFriendRemoveOutbound } from '../../api/outbound/friendsOutbounds';
import { OpenModalContainer } from '../../components/openModalContainer';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { thunkSetActivePanel } from '../../redux/actions/panelsActions';
import { useAppDispatch } from '../../redux/store';
export const RemoveFriendModal = ({ username, onClose }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClickUnfriend = useCallback(() => {
        socketSend(createFriendRemoveOutbound(username));
        dispatch(thunkSetActivePanel('friends', socketSend));
        onClose();
    }, [socketSend, username, dispatch, onClose]);
    return (_jsx(OpenModalContainer, { title: `${username} is your friend`, onClose: onClose, children: _jsx(DialogActions, { children: _jsxs(Button, { variant: 'contained', color: 'secondary', onClick: onClickUnfriend, children: ["Unfriend ", username] }) }) }));
};
